import React from 'react';
import { useLocation } from 'react-router-dom';

import { CssBaseline } from '@mui/material';
import Box from '@mui/material/Box';

import { stylesMainContent, stylesMainContentBody, stylesMainLayout } from '@/features/layouts/MainLayout.styles';
import { Header, NavigationDrawer } from '@/features/layouts/components';

type MainLayoutProps = {
  children: React.ReactNode;
};

export function MainLayout({ children }: MainLayoutProps) {
  const { pathname } = useLocation();

  const [isSideBarDrawerOpen, setIsSideBarDrawerOpen] = React.useState(false);

  const handleHoverSideBarDrawer = () => {
    setIsSideBarDrawerOpen((isOpen) => !isOpen);
  };
  const hasToDisplayDrawer = !pathname.includes('/pre-folders') && !['/404', '/subscribe'].includes(pathname);
  const hasToDisplayHeader = !pathname.startsWith('/pre-folders');

  return (
    <Box sx={stylesMainLayout}>
      <CssBaseline />
      {hasToDisplayDrawer && (
        <NavigationDrawer
          isSideBarDrawerOpen={isSideBarDrawerOpen}
          onHoverOpenSideBarDrawer={handleHoverSideBarDrawer}
        />
      )}
      <Box data-testid='main-box' component='main' sx={hasToDisplayDrawer ? stylesMainContent : undefined}>
        {hasToDisplayHeader && <Header />}
        <Box sx={stylesMainContentBody}>{children}</Box>
      </Box>
    </Box>
  );
}
